import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ServiceType, serviceSearchParams } from '../../types/resources/ServiceType';

type ResponseType = {
  data: {
    services: ServiceType[];
  };
  headers: Record<string, string>;
};

export async function getServices(
  signOut?: () => void,
  searchParams?: serviceSearchParams
): Promise<ResponseType> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `/partner_admins/services${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}
